import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingsMessagingAppsAppEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const helpCenterSettingsMessagingAppsAppEntryPoint: EntryPoint<
	HelpCenterSettingsMessagingAppsAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsMessagingAppsAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-messaging-apps-app" */ './HelpCenterSettingsMessagingAppsApp.tsx',
	),
	getPreloadProps: () => ({}),
});
